import React, { useState } from 'react';
import { MathRenderer } from '../shared/MathRenderer';
import { AnswerInput } from '../practice/AnswerInput';
import { Timer } from '../shared/Timer';

interface GateQuestionProps {
  questionNumber: number;
  totalQuestions: number;
  prompt: string;
  answerType: string;
  choices?: { label: string; value: string }[];
  timeRemaining: number;
  onSubmit: (answer: string) => void;
  onTimeout: () => void;
}

export const GateQuestion: React.FC<GateQuestionProps> = ({
  questionNumber,
  totalQuestions,
  prompt,
  answerType,
  choices,
  timeRemaining,
  onSubmit,
  onTimeout,
}) => {
  const [answer, setAnswer] = useState('');

  const handleSubmit = () => {
    if (answer.trim()) {
      onSubmit(answer);
      setAnswer('');
    }
  };

  return (
    <div className="gate-question">
      <div className="gate-header">
        <span className="question-number">
          Question {questionNumber} of {totalQuestions}
        </span>
        <Timer
          seconds={0}
          onTimeout={onTimeout}
          timeRemaining={timeRemaining}
        />
      </div>

      <div className="gate-progress">
        <div
          className="gate-progress-fill"
          style={{ width: `${(questionNumber / totalQuestions) * 100}%` }}
        />
      </div>

      <div className="question-content">
        <MathRenderer content={prompt} />
      </div>

      <AnswerInput
        type={answerType}
        choices={choices}
        value={answer}
        onChange={setAnswer}
        onSubmit={handleSubmit}
      />

      <button
        className="submit-answer"
        onClick={handleSubmit}
        disabled={!answer.trim()}
      >
        Submit Answer
      </button>
    </div>
  );
};
